import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import InstarVisionMenuCards01 from 'components/Software/macOS/InstarVision/Advanced/instarVisionMenuCards01';
import InstarVisionMenuCards02 from 'components/Software/macOS/InstarVision/Advanced/instarVisionMenuCards02';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  InstarVisionMenuCards01,
  InstarVisionMenuCards02,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};